/* ── Bell wrapper (positions the dropdown) ── */
.wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
}

/* ── Bell icon button — matches AppBar iconBtn pattern ── */
.bellBtn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: var(--nexus-radius-full);
  border: 1px solid transparent;
  background: transparent;
  color: var(--nexus-text-muted);
  cursor: pointer;
  position: relative;
  transition:
    color 200ms ease,
    border-color 200ms ease,
    box-shadow 200ms ease,
    transform 120ms ease;
}

/* radial glow behind icon on hover */
.bellBtn::before {
  content: '';
  position: absolute;
  inset: -2px;
  border-radius: inherit;
  background: radial-gradient(
    circle,
    rgba(var(--appbar-accent-rgb, 178, 75, 243), 0.15) 0%,
    rgba(var(--appbar-accent-rgb, 178, 75, 243), 0.08) 50%,
    transparent 70%
  );
  opacity: 0;
  transition: opacity 200ms ease;
  pointer-events: none;
}

.bellBtn:hover {
  color: var(--appbar-accent, var(--nexus-purple));
  border-color: rgba(var(--appbar-accent-rgb, 178, 75, 243), 0.4);
  box-shadow: 0 0 14px -3px rgba(var(--appbar-accent-rgb, 178, 75, 243), 0.35);
}

.bellBtn:hover::before {
  opacity: 1;
}

.bellBtn:active {
  color: var(--nexus-pink);
  border-color: var(--nexus-pink);
  transform: scale(0.88);
  box-shadow: 0 0 8px -2px rgba(255, 45, 138, 0.4);
}

.bellBtnActive {
  color: var(--appbar-accent, var(--nexus-purple));
  border-color: rgba(var(--appbar-accent-rgb, 178, 75, 243), 0.4);
}

.bellBtnActive::before {
  opacity: 1;
}

/* ── Unread count badge ── */
.badge {
  position: absolute;
  top: 2px;
  right: 2px;
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  border-radius: var(--nexus-radius-full);
  background: var(--nexus-pink);
  color: #fff;
  font-size: 0.625rem;
  font-weight: var(--nexus-weight-bold);
  line-height: 16px;
  text-align: center;
  pointer-events: none;
  box-shadow: 0 0 0 2px var(--nexus-bg);
}
